import { useTranslation } from "react-i18next";
import { Checkbox, Popover, Image } from "antd";

const CancelBox = ({
  data,
  handleFilterSelection,
  isFiltersLoadingInline,
  selectedFilters,
}) => {
  const { t, i18n } = useTranslation("common");
  const isEn = i18n.language === "en";

  const handleCancelCheck = (e) => {
    e?.stopPropagation();
    const isChecked = e?.target?.checked;
    handleFilterSelection("cancel", true, isChecked);
  };

  return (
    <article className="w-full border-t-green border-t-4 py-3 lg:px-5 px-4 border rounded-2xl">
      <h3 className="font-bold text-lg mb-[10px]">
        {t("search.filter_Stornierungsbedingungen")}
      </h3>

      <Checkbox
        className="search_checkbox"
        onChange={handleCancelCheck}
        disabled={isFiltersLoadingInline}
        checked={selectedFilters?.[0]?.includes("1")}
      >
        <p
          className={`text-base ${
            selectedFilters?.[0]?.includes("1") ? "font-medium" : "font-normal"
          }`}
        >
          {isEn
            ? data?.title_en ?? data?.title_de
            : data?.title_de ?? data?.title_en}
          {data?.count && ` (${data?.count})`}
        </p>
      </Checkbox>

      <Popover
        content={
          <p className="w-[300px]">
            {isEn
              ? data?.more_info_en ?? t("search.cancel_filter_hint")
              : data?.more_info_de ?? t("search.cancel_filter_hint")}
          </p>
        }
        trigger="hover"
        placement="topLeft"
      >
        <div className="flex cursor-pointer items-center mt-4 gap-x-2">
          <p className="text-green underline text-base">
            {t("offer.more_info")}
          </p>
          <div className="flex">
            <Image
              src="/icon/search/info.svg"
              alt="info"
              preview={false}
              width={15}
              height={15}
              loading="lazy"
            />
          </div>
        </div>
      </Popover>
    </article>
  );
};

export default CancelBox;
